import React, { useState, useEffect } from 'react'

import Layout from '../Layout/Layout'
import { url, header } from "../Constent/Constant";

const PrivacyPolicy = () => {
    const [PolicyData, setPolicyData] = useState('')

    useEffect(() => {
        fetch(`${url}/page/viewpagedata`, {
            method: 'POST',
            body: JSON.stringify({
                name: "Privacy Policy"
            }),
            headers: header
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setPolicyData(data.doc)
            })
    }, [])
    return (
        <Layout>
            {PolicyData && <div className='Policy-container'>
                <h1 className='Heading'>PRIVACY POLICY</h1>
                <h2>{PolicyData.section1heading1.content}</h2>
                <p>{PolicyData.section1paragraph1.content}</p>
                <h2>{PolicyData.section2heading1.content}</h2>
                <p>{PolicyData.section2paragraph1.content}</p>
                <h2>{PolicyData.section3heading1.content}</h2>
                <p>{PolicyData.section3paragraph1.content}</p>
                <h2>{PolicyData.section4heading1.content}</h2>
                <p>{PolicyData.section4paragraph1.content}</p>
                <h2>{PolicyData.section5heading1.content}</h2>
                <p>{PolicyData.section5paragraph1.content}</p>
                <h2>{PolicyData.section6heading1.content}</h2>
                <p>{PolicyData.section6paragraph1.content}</p>
                <h2>{PolicyData.section7heading1.content}</h2>
                <p>{PolicyData.section7paragraph1.content}</p>
                <h2>{PolicyData.section8heading1.content}</h2>
                <p>{PolicyData.section8paragraph1.content}</p>
                <h2>{PolicyData.section9heading1.content}</h2>
                <p>{PolicyData.section9paragraph1.content}</p>
                <h2>{PolicyData.section10heading1.content}</h2>
                <p>{PolicyData.section10paragraph1.content}</p>
                <p className='Details'>7756B N W 44th Street</p>
                <p> Sunrise FL 33351 </p>
                <a href='mailto: info@onthegorelocation.com'>info@onthegorelocation.com </a>
                <br />
                <br />
                <a href="tel: 844-346-2264"> 844-346-2264 </a>
            </div>}
        </Layout>
    )
}

export default PrivacyPolicy
